export default "__VITE_ASSET__AXFnZ9Bw__"